/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState } from "react";
import CustomEditCard from "../../../../common/components/CustomEditCard/CustomEditCard";
import CardContentTile from "../../../../common/components/CardContentTile/CardContentTile";
import { Box } from "@mui/system";
import BankDetailModalController from "../../../../common/Modals/PersonalDetails/BankDetailModal/BankDetailModalController";
import _ from "lodash";
import { Typography } from "@mui/material";

interface propsType {
  bankInfoData: any;
  hr_view?: boolean;
  trans?: any;
  fields_of_exchange?: any;
  fields_of_banks?: any;
}
const EmergencyContactPresenter: React.FC<propsType> = ({
  bankInfoData,
  hr_view,
  trans,
  fields_of_banks,
  fields_of_exchange,
}) => {
  const [openModal, setOpenModal] = useState(false);
  const excludeKeys = ['company_mode_of_payment', 'company_bank_or_exchange'];

  const bankDetailsArray = bankInfoData?.bankdetails
    ? Object.entries(bankInfoData.bankdetails)
      .map(([key, value]) => ({ key, value }))
      .filter((item) => !excludeKeys.includes(item.key))
    : [];

  const exchangeDetailsArray = bankInfoData?.exchange
    ? Object.entries(bankInfoData.exchange)
      .map(([key, value]) => ({ key, value }))
      .filter((item) => !excludeKeys.includes(item.key))
    : [];
  const compBankDetailsArray = bankInfoData?.bankdetails
    ? Object.entries(bankInfoData?.bankdetails)
      .map(([key, value]) => ({ key, value }))
      .filter((item) => excludeKeys.includes(item.key))
    : [];

  const compExchangeDetailsArray = bankInfoData?.exchange
    ? Object.entries(bankInfoData?.exchange)
      .map(([key, value]) => ({ key, value }))
      .filter((item) => excludeKeys.includes(item.key))
    : [];
  return (
    <div>
      <CustomEditCard
        card_title={trans("Bank / Exchange Details")}
        card_height="400px"
        onClick={() => setOpenModal(true)}
        showEditButton={hr_view}
      >
        <Box style={{ marginBottom: "24px" }} />
        {bankDetailsArray.length > 0 && (
          <>
            <Box
              sx={{
                border: '1px solid #E6E8F0',
                borderRadius: '12px',
                backgroundColor: '#fff',
                padding: '16px',
                marginBottom: '20px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 700,
                  color: '#111827',
                  marginBottom: '16px',
                  borderBottom: '1px solid #ECEEF5',
                  paddingBottom: '10px',
                }}
              >
                Bank
              </Typography>
              {bankDetailsArray?.length > 0 &&
                _.map(bankDetailsArray, (bank: any) => {
                  return _.map(fields_of_banks, (f: any) => {
                    if (f?.field_name == bank?.key) {
                      return (
                        <div key={bank?.key}>
                          <CardContentTile
                            tile_key={trans(f?.name)}
                            tile_value={trans(bank?.value)}
                          />
                        </div>
                      );
                    }
                  });
                })}

              {compBankDetailsArray?.length > 0 &&
                _.map(compBankDetailsArray, (bank: any) => {
                  return _.map(fields_of_banks, (f: any) => {
                    if (f?.field_name == bank?.key) {
                      return (
                        <div key={bank?.key}>
                          <CardContentTile
                            tile_key={trans(f?.name)}
                            tile_value={trans(bank?.value)}
                          />
                        </div>
                      );
                    }
                  });
                })}
            </Box>
          </>
        )}

        {exchangeDetailsArray?.length > 0 && (
          <>
            <Box
              sx={{
                border: '1px solid #E6E8F0',
                borderRadius: '12px',
                backgroundColor: '#fff',
                padding: '16px',
                marginBottom: '20px',
              }}
            >
              <Typography
                sx={{
                  fontSize: '14px',
                  fontWeight: 700,
                  color: '#111827',
                  marginBottom: '16px',
                  borderBottom: '1px solid #ECEEF5',
                  paddingBottom: '10px',
                }}
              >
                Exchange
              </Typography>
              {exchangeDetailsArray?.length > 0 &&
                _.map(exchangeDetailsArray, (bank: any) => {
                  return _.map(fields_of_exchange, (f: any) => {
                    if (f?.field_name == bank?.key) {
                      return (
                        <div key={bank?.key}>
                          <CardContentTile
                            tile_key={trans(f?.name)}
                            tile_value={trans(bank?.value)}
                          />
                        </div>
                      );
                    }
                  });
                })}

              {compExchangeDetailsArray?.length > 0 &&
                _.map(compExchangeDetailsArray, (bank: any) => {
                  return _.map(fields_of_exchange, (f: any) => {
                    if (f?.field_name == bank?.key) {
                      return (
                        <div key={bank?.key}>
                          <CardContentTile
                            tile_key={trans(f?.name)}
                            tile_value={trans(bank?.value)}
                          />
                        </div>
                      );
                    }
                  });
                })}
            </Box>
          </>
        )}
      </CustomEditCard>

      {/* Bank Info Modal */}

      {
        openModal && (
          <BankDetailModalController
            isModalOpen={openModal}
            closeModal={() => setOpenModal(false)}
            trans={trans}
            bankInfoData={bankInfoData}
          />
        )
      }
    </div >
  );
};

export default EmergencyContactPresenter;
